import React from 'react';
import { IconProps } from '../types';

export const WebAppDesignIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.99992 3.66663C3.07944 3.66663 2.33325 4.41282 2.33325 5.33329V26.6666C2.33325 27.5871 3.07944 28.3333 3.99992 28.3333H22.3333V30.3333H3.99992C1.97487 30.3333 0.333252 28.6917 0.333252 26.6666V5.33329C0.333252 3.30825 1.97487 1.66663 3.99992 1.66663H26.6666C28.6916 1.66663 30.3333 3.30825 30.3333 5.33329V10.3333H28.3333V5.33329C28.3333 4.41282 27.5871 3.66663 26.6666 3.66663H3.99992Z"
            fill={color}
        />
        <path
            d="M5.33325 7.99996C6.06963 7.99996 6.66658 7.40301 6.66658 6.66663C6.66658 5.93025 6.06963 5.33329 5.33325 5.33329C4.59687 5.33329 3.99992 5.93025 3.99992 6.66663C3.99992 7.40301 4.59687 7.99996 5.33325 7.99996Z"
            fill={color}
        />
        <path
            d="M9.33325 7.99996C10.0696 7.99996 10.6666 7.40301 10.6666 6.66663C10.6666 5.93025 10.0696 5.33329 9.33325 5.33329C8.59687 5.33329 7.99992 5.93025 7.99992 6.66663C7.99992 7.40301 8.59687 7.99996 9.33325 7.99996Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.3333 11.6666C21.1495 11.6666 20.9999 11.8162 20.9999 12V28C20.9999 28.1837 21.1495 28.3333 21.3333 28.3333H29.3333C29.517 28.3333 29.6666 28.1837 29.6666 28V12C29.6666 11.8162 29.517 11.6666 29.3333 11.6666H21.3333ZM18.9999 12C18.9999 10.7117 20.045 9.66663 21.3333 9.66663H29.3333C30.6215 9.66663 31.6666 10.7117 31.6666 12V28C31.6666 29.2882 30.6215 30.3333 29.3333 30.3333H21.3333C20.045 30.3333 18.9999 29.2882 18.9999 28V12Z"
            fill={color}
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M18.9999 23H31.6666V25H18.9999V23Z" fill={color} />
    </svg>
);
